import { ReservaSalaEvents, ReservaSalaInfo, ReservaSalaResource, SendReservaSala, PrecaucoesFromTasy, MotivoTransferenciaReserva } from '@/types/_'
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import { IReservaSala, ReservaSala } from '@/types/implements/ReservaSala'
import { getColorFromReservaSala, getDateTimeCurrentWeekByWeekdayString, parseShiftInfo } from '@/utils/common'
import moment from 'moment'
import { ReservaSalaCentroCirurgico, ReservaSalaConfiguracoes } from '@/types/interfaces/ReservaSala'
import Apis from '@/Apis/_'
import { HospitalRede } from '@/types/interfaces/HospitalRede'

@Module({ namespaced: true, name: 'ReservaSalaStore' })
export default class ReservaSalaStore extends VuexModule {
  reservaSalasResource: ReservaSalaResource[] = []
  reservaSalasResourceApi: ReservaSalaResource[] = []
  reservaSalasEvent: ReservaSalaEvents[] = []
  roomConfigurationEvents: any = []
  roomResources: any = []

  private reservaSalaInfoDefault: ReservaSalaInfo = {
    dataAgendamento: '',
    salaCirurgicaId: '',
    centroCirurgicoId: '',
    tipoCentroCirurgico: '',
    dataAgendamentoMensagens: [],
    dataAgendamentoVirtual: undefined,
    instrucaoData: '',
    numeroAgendamento: '',
    opcaoDataPrevisto1: '',
    opcaoDataPrevisto2: '',
    opcaoDataPrevisto3: '',
    hospitalId: '',
    dataAntecedenciaDeInternacao: '',
  }

  reservaSalaInfo: ReservaSalaInfo = { ...this.reservaSalaInfoDefault }

  public modalReservaSala: boolean = false
  public precaucoesFromTasy: PrecaucoesFromTasy[] = []

  reservaSala: IReservaSala = new ReservaSala()

  configuracoesDefault: ReservaSalaConfiguracoes = {
    dataVirtualFazReservaDeSala: true,
    exibeCampoParaInformarSeGuiaFoiCanceladaNaOperadora: true,
    hospitalPreencheNumeroDaReserva: true,
    informaMotivoTransferenciaReserva: false,
  }

  configuracoes: ReservaSalaConfiguracoes = { ...this.configuracoesDefault }
  centrosCirurgicos: ReservaSalaCentroCirurgico[] = []

  surgeryCenter = {
    data: {} as ReservaSalaCentroCirurgico,
  }

  roomChecked = {
    data: {} as ReservaSalaResource,
  }

  hospitalSelecionado = {
    data: {} as HospitalRede,
  }

  motivosTransferenciaReserva: MotivoTransferenciaReserva[] = []
  hospitaisRede: HospitalRede[] = []

  @Mutation
  setPrecaucoesFromTasy(value: PrecaucoesFromTasy[]) {
    this.precaucoesFromTasy = value.filter((e: PrecaucoesFromTasy) => !['', null, undefined].includes(e.tipo) && !['', null, undefined].includes(e.descricao))
  }

  @Mutation
  clearPrecaucoesFromTasy() {
    this.precaucoesFromTasy = []
  }

  @Action
  async sendReservaSala(params: SendReservaSala) {
    const response = await this.reservaSala.sendReservaSalas(params)
    return response
  }

  @Action
  async getRoomConfigurationData({ surgeryCenterId, hospitalId }) {
    const roomsResponse = await this.reservaSala.getRoomConfigurationBySurgeryCenterAndHospital({ centroCirurgicoId: surgeryCenterId, hospitalId })
    const shiftsResponse = await this.getRoomShiftConfigurationBySurgeryCenterAndHospital({ surgeryCenterId, hospitalId })

    if (roomsResponse.success && shiftsResponse.success) {
      const { salaCentroCirurgico } = roomsResponse.data
      salaCentroCirurgico.turnos = shiftsResponse.data.turnos
      this.context.commit('setRoomConfigurationEvent', salaCentroCirurgico)
    }

    return { roomsResponse, shiftsResponse }
  }

  @Action
  async getRoomStatusSurgeryCenter(params) {
    const { roomId, hospitalId } = params

    const APIRequest = await this.reservaSala.getRoomStatusBySurgeryCenterAndHospital({ salaCentroCirurgicoId: roomId, hospitalId })
    return APIRequest
  }

  @Action
  async getRoomShiftConfigurationBySurgeryCenterAndHospital(params) {
    const { surgeryCenterId, hospitalId } = params

    const APIRequest = await this.reservaSala.getRoomShiftConfigurationBySurgeryCenterAndHospital({ centroCirurgicoId: surgeryCenterId, hospitalId })
    return APIRequest
  }

  @Action
  async getRoomAvailabilityCalendar(queryParams) {
    const { hospitalId, availabilityDate, roomId, searchType } = queryParams

    const APIRequest = await this.reservaSala.getRoomAvailabilityCalendar({
      hospitalId,
      salaCirurgicaId: roomId,
      dataIndisponibilidade: availabilityDate,
      tipoBusca: searchType,
    })
    return APIRequest
  }

  @Action
  async updateRoomAvailabilityCalendar(requestBody) {
    const { roomId, hospitalId, reasonDeactivation, roomActive, id, calendarAvailabilityDate } = requestBody
    const parsedRequestBody: any = {
      hospitalId,
      salaCirurgicaId: roomId,
      motivoSalaInativa: reasonDeactivation,
      salaAtiva: roomActive,
      dataIndisponibilidade: calendarAvailabilityDate,
    }

    if (id) {
      parsedRequestBody.id = id
    }

    const APIRequest = await this.reservaSala.updateRoomAvailabilityCalendar(parsedRequestBody)
    return APIRequest
  }

  @Action
  async updateRoomStatusSurgeryCenter(params) {
    const APIRequest = await this.reservaSala.updateRoomStatusSurgeryCenter(params)
    return APIRequest
  }

  @Action
  async updateReservationLimitDate(requestBody) {
    const { limitDays, hospitalId } = requestBody
    const parsedRequestBody: any = {
      hospitalId,
      maximoDiasMedicoSemReserva: limitDays,
    }

    const APIRequest = await this.reservaSala.updateReservationLimitDate(parsedRequestBody)
    return APIRequest
  }

  @Action
  async deleteRoomAvailability(params) {
    const response = await this.reservaSala.deleteRoomAvailability(params)
    return response
  }


  @Action
  async updateShiftConfiguration(params) {
    const response = await this.reservaSala.updateShiftConfiguration(params)
    return response
  }

  @Action
  async updateRoomConfiguration(params) {
    const response = await this.reservaSala.updateRoomConfiguration(params)
    return response
  }

  @Action
  async getDoctors() {
    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.getMedicoshospitalByUserCurrent()

    if (request.success) {
      const medicosCast = await this
        .forceCast<Array<{ id: string, nome: string }[]>>(request.data)
      return medicosCast
    }
    return []
  }

  @Action
  async getSpecialties() {
    const request = await Apis.Cadastro.CadastroApi.getCbosAll()

    if (request.success) {
      const medicosCast = await this
        .forceCast<Array<{ id: string, descricao: string }[]>>(request.data)
      return medicosCast
    }
    return []
  }

  @Action
  forceCast<T>(obj: any) {
    return obj
  }

  @Action
  async getReservaSalas(params) {
    const { isDoctor } = params
    let response

    if (isDoctor) {
      response = await this.reservaSala.getDoctorRoomReservations(params)
    } else {
      response = await this.reservaSala.getReservaSalas(params)
    }

    if (response.success) {
      const reservationsData = {
        reservations: response.data.reservas,
        doctorPreviewData: {
          ...params,
        },
      }

      this.context.commit('setReservaSalaResourceApi', response.data.salas || [])
      this.context.commit('setReservaSalaEventApi', reservationsData)
      this.context.commit('setReservaSalaInfoApi', response.data.solicitacao || {})
      this.context.commit('setPrecaucoesFromTasy', response.data.precaucoes || [])
      this.context.commit('setConfiguracoes', response.data.configuracoes || {})
      this.context.commit('setCentrosCirurgicos', response.data.centrosCirurgicos || [])
      this.context.commit('setMotivosTransferenciaReserva', response.data.motivosTransferenciaReserva || [])
      this.context.commit('setHospitaisRede', response.data.hospitaisRede || [])

      await this.context.dispatch('updateSelectedSurgeryCenterById', this.reservaSalaInfo.centroCirurgicoId)
      await this.context.dispatch('updateReservaSalaResource')
      await this.context.dispatch('updateSelectedRoomCheckedById', this.reservaSalaInfo.salaCirurgicaId)
      await this.context.dispatch('updateHospitalSelecionadoById', this.reservaSalaInfo.hospitalId)
    }

    return response
  }

  @Action
  async getTipoObjetoPost(params: any) {
    if (this.reservaSalaInfo.dataAgendamentoVirtual && !this.configuracoes.dataVirtualFazReservaDeSala) return { reservaVirtual: params }
    return { reservaSala: params }
  }


  @Mutation
  setMotivosTransferenciaReserva(data: MotivoTransferenciaReserva[]) {
    this.motivosTransferenciaReserva = data
  }

  @Mutation
  setHospitaisRede(data: HospitalRede[]) {
    this.hospitaisRede = data
  }

  @Mutation
  setConfiguracoes(value: ReservaSalaConfiguracoes) {
    this.configuracoes = value
  }

  @Mutation
  setCentrosCirurgicos(value: ReservaSalaCentroCirurgico[]) {
    this.centrosCirurgicos = value

    if (value.length === 1) {
      const { id, nome, salas } = this.centrosCirurgicos[0]
      this.surgeryCenter.data = {
        id,
        nome,
        salas,
      }
    }
  }

  @Mutation
  clearCentrosCirurgicos() {
    this.centrosCirurgicos = []
  }

  @Mutation
  clearHospitaisRede() {
    this.hospitaisRede = []
  }

  @Mutation
  setReservaSalaResourceApi(values: any[]) {
    this.reservaSalasResourceApi = values
    this.reservaSalasResource.splice(0, this.reservaSalasResource.length)

    values.forEach((c) => {
      const reservaSala: ReservaSalaResource = {
        eventColor: '#1565C0',
        id: c.id,
        title: c.nome,
      }

      if (!this.reservaSalasResource.some(r => r.id === c.id)) {
        this.reservaSalasResource.push(reservaSala)
      }

      return c
    })
  }


  @Mutation
  setRoomConfigurationEvent(roomInfo) {
    this.roomResources.splice(0, this.roomResources.length)
    this.roomConfigurationEvents.splice(0, this.roomConfigurationEvents.length)

    roomInfo.forEach((roomData) => {
      roomData.disponibilidadeSala.forEach((roomAvailability) => {
        const { diaDaSemana: weekday,
          urgencia: isUrgency,
          responsaveis: responsiblePeople,
          tipoDisponibilidade: availabilityType,
          salaAtiva: isActive,
          configuracaoTurno: shiftConfiguration,
          motivoSalaInativa: reasonDeactivation,
          configuracaoTurno: shift } = roomAvailability

        let backgroundColor
        let title

        if (availabilityType.toLowerCase() === 'sus') {
          backgroundColor = '#FFC20F'
        } else if (availabilityType.toLowerCase() === 'particular') {
          backgroundColor = '#1565C0'
        } else if (availabilityType.toLowerCase() === 'livre') {
          backgroundColor = '#00A96B'
        }

        if (!isActive && reasonDeactivation) {
          backgroundColor = '#A8422D'

          if (reasonDeactivation === 'NaoInstalada') {
            title = 'Não Instalada'
          } else if (reasonDeactivation === 'NaoOperacional') {
            title = 'Não Operacional'
          }
        } else if (availabilityType.toLowerCase() === 'livre') {
          title = 'Livre'
        } else {
          title = 'Reservado'
        }

        const startDateTime = getDateTimeCurrentWeekByWeekdayString(weekday)
        const endDateTime = getDateTimeCurrentWeekByWeekdayString(weekday)

        startDateTime && startDateTime.setHours(0, 0, 0).toString()
        endDateTime && endDateTime.setHours(23, 59, 0).toString()

        let currentShift

        if (shift.descricaoTurno.toLowerCase() === 'manhã') {
          currentShift = 'morning'
        } else if (shift.descricaoTurno.toLowerCase() === 'tarde') {
          currentShift = 'afternoon'
        } else if (shift.descricaoTurno.toLowerCase() === 'noite') {
          currentShift = 'night'
        }

        const resourceId = `${currentShift}/${roomData.id}`
        const event = {
          id: `event/${resourceId}/${weekday}/${roomAvailability.id}`,
          shift: currentShift,
          shiftConfiguration,
          resourceId,
          roomId: roomData.id,
          start: startDateTime,
          end: endDateTime,
          label: availabilityType,
          availabilityType,
          weekday,
          isUrgency,
          isActive,
          reasonDeactivation,
          roomAvailabilityId: roomAvailability.id,
          responsiblePeople,
          description: availabilityType === 'Particular' ? 'Convênio/Particular' : availabilityType,
          title,
          textColor: '#FFF',
          backgroundColor,
          borderColor: backgroundColor,
          allDay: true,
          roomAvailability: roomData.disponibilidadeSala,
        }
        this.roomConfigurationEvents.push(event)
      })

      const shiftsInfo: any = []

      const morningShiftInfo = roomInfo.turnos.find(shift => shift.descricao === 'Manhã')
      const afternoonShiftInfo = roomInfo.turnos.find(shift => shift.descricao === 'Tarde')
      const nightShiftInfo = roomInfo.turnos.find(shift => shift.descricao === 'Noite')

      if (morningShiftInfo) {
        shiftsInfo.push({ shiftId: morningShiftInfo.id, id: `morning/${roomData.id}`, title: morningShiftInfo.descricao })
      }

      if (afternoonShiftInfo) {
        shiftsInfo.push({ shiftId: afternoonShiftInfo.id, id: `afternoon/${roomData.id}`, title: afternoonShiftInfo.descricao })
      }

      if (nightShiftInfo) {
        shiftsInfo.push({ shiftId: nightShiftInfo.id, id: `night/${roomData.id}`, title: nightShiftInfo.descricao })
      }

      const resourceData = {
        id: roomData.id,
        title: `${roomData.nome}${!roomData.ativa ? ' (Inativa)' : ''}`,
        isActive: roomData.ativa,
        reasonDeactivation: typeof roomData.motivoSalaInativa === 'string' ? roomData.motivoSalaInativa : null,
        children: shiftsInfo,
      }
      this.roomResources.push(resourceData)
    })
  }

  @Mutation
  setReservaSalaEventApi(eventInfo) {
    this.reservaSalasEvent.splice(0, this.reservaSalasEvent.length)

    eventInfo.reservations.forEach((c) => {
      const startTime = moment(c.inicio).format('HH:mm')
      const endTime = moment(c.fim).format('HH:mm')
      const medicoNome = c.medicoNome ? `${c.medicoNome} -` : ''
      const tooltipValue = `${medicoNome} ${startTime} às ${endTime}`
      const dataReserva: ReservaSalaEvents = {
        dataAgendamentoVirtual: c.dataAgendamentoVirtual,
        title: '',
        description: tooltipValue,
        end: c.fim,
        resourceId: c.salaCirurgicaId,
        solicitacaoId: c.solicitacaoId,
        start: c.inicio,
        preparoDaSala: c.preparoDaSala,
        tipoReservaSala: c.tipoReservaSala,
        backgroundColor: getColorFromReservaSala(
          c.tipoReservaSala,
          {
            isDoctor: eventInfo.doctorPreviewData.isDoctor,
            isLoggedinDoctor: c.reservaMedicoLogado,
          },
        ),
        borderColor: '#fff',
        solicitacaoAutorizada: c.solicitacaoAutorizada,
      }

      if (!this.reservaSalasEvent.some(r => r.solicitacaoId === c.solicitacaoId && r.resourceId === c.salaCirurgicaId && r.tipoReservaSala === c.tipoReservaSala)) {
        this.reservaSalasEvent.push(dataReserva)
      }
    })
  }

  @Mutation
  setReservaSalaInfoApi(value: ReservaSalaInfo) {
    const numeroAgendamentoForm = this.reservaSalaInfo && this.reservaSalaInfo.numeroAgendamento
    const dataAgendamentoVirtualForm = this.reservaSalaInfo && this.reservaSalaInfo.dataAgendamentoVirtual
    const numeroAgendamentoApi = value && value.numeroAgendamento
    const dataAgendamentoVirtualApi = value && value.dataAgendamentoVirtual

    this.reservaSalaInfo = {
      ...value,
      numeroAgendamento: numeroAgendamentoForm || numeroAgendamentoApi,
      dataAgendamentoVirtual: dataAgendamentoVirtualForm !== undefined ? dataAgendamentoVirtualForm : dataAgendamentoVirtualApi,
    }
  }

  @Mutation
  resetReservaSalaInfoApi() {
    this.reservaSalaInfo = { ...this.reservaSalaInfoDefault }
  }

  @Mutation
  setReservaSalaEvent(value: ReservaSalaEvents) {
    this.reservaSalasEvent.push(value)
  }

  @Mutation
  updateReservaSalaEvent(params: any) {
    this.reservaSalasEvent.map((c) => {
      const r = c
      if (r.solicitacaoId === params.solicitacaoId) {
        r.start = params.start
        r.end = params.end
      }
      return r
    })
  }

  @Mutation
  deleteReservaSalaEvent(solicitacaoId: string) {
    if (this.reservaSalasEvent.some(c => c.solicitacaoId === solicitacaoId)) {
      const reservas = this.reservaSalasEvent.filter(c => c.solicitacaoId === solicitacaoId)
      reservas.map((c) => {
        const index = this.reservaSalasEvent.findIndex(i => i.solicitacaoId === c.solicitacaoId)
        this.reservaSalasEvent.splice(index, 1)
        return c
      })
    }
  }

  @Mutation
  setShowModalReservaSala(value: boolean) {
    this.modalReservaSala = value
  }

  @Mutation
  clearReservaSalasResource() {
    this.reservaSalasResource.splice(0, this.reservaSalasResource.length)
  }

  @Mutation
  clearReservaSalaEvent() {
    this.reservaSalasEvent.splice(0, this.reservaSalasEvent.length)
  }

  @Mutation
  setSurgeryCenter(value: ReservaSalaCentroCirurgico) {
    this.surgeryCenter.data = value
  }

  @Mutation
  setHospitalSelecionado(value: any) {
    this.hospitalSelecionado.data = value
  }

  @Mutation
  clearHospitalSelecionado() {
    this.hospitalSelecionado.data = {} as HospitalRede
  }

  @Mutation
  clearSurgeryCenter() {
    this.surgeryCenter.data = {} as ReservaSalaCentroCirurgico
  }

  @Mutation
  setRoomChecked(value: ReservaSalaResource) {
    this.roomChecked.data = value
  }

  @Mutation
  clearRoomChecked() {
    this.roomChecked.data = {} as ReservaSalaResource
  }

  @Action
  updateReservaSalaResource() {
    this.setReservaSalaResourceApi(this.surgeryCenter.data.salas || this.reservaSalasResourceApi)
  }

  @Action
  updateSelectedRoomCheckedById(id: string) {
    const roomChecked = this.reservaSalasResource.find(c => c.id === id)
    if (roomChecked) {
      this.context.commit('setRoomChecked', roomChecked)
    }
  }

  @Action
  async updateSelectedSurgeryCenterById(id: string) {
    const surgeryCenter = this.centrosCirurgicos.find(elem => elem.id === id)
    if (surgeryCenter && !this.surgeryCenter.data.id) {
      this.context.commit('setSurgeryCenter', surgeryCenter)
    }
  }

  @Action
  async updateHospitalSelecionadoById(id: string) {
    const hospitalSelecionado = !this.hospitalSelecionado.data.id ? this.hospitaisRede.find(elem => elem.id === id) : this.hospitalSelecionado.data
    if (hospitalSelecionado) {
      this.context.commit('setHospitalSelecionado', hospitalSelecionado)
    }
  }
}
